/* Atlas horizontal rails, ported from ac-cat-v2 home-rail.js (Community, Releases).
   Prev/next scroll one card; a rail with a progress thumb also drives the thumb and arrow dimming. */
(function () {
  function init(root) {
    var el = root.querySelector('[data-rail-scroll]');
    if (!el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
    }
    var gap = parseInt(root.getAttribute('data-gap'), 10) || 10;
    var thumb = root.querySelector('[data-rail-thumb]');
    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');
    function by(d) {
      var c = el.firstElementChild;
      el.scrollBy({ left: d * (c ? c.getBoundingClientRect().width + gap : 300), behavior: 'smooth' });
    }
    function update() {
      var max = el.scrollWidth - el.clientWidth;
      if (thumb) {
        thumb.style.width = (el.scrollWidth ? el.clientWidth / el.scrollWidth : 1) * 100 + '%';
        thumb.style.left = (el.scrollWidth ? el.scrollLeft / el.scrollWidth : 0) * 100 + '%';
      }
      if (prev && thumb) prev.style.opacity = el.scrollLeft <= 2 ? '0.35' : '1';
      if (next && thumb) next.style.opacity = el.scrollLeft >= max - 2 ? '0.35' : '1';
    }
    if (prev) prev.addEventListener('click', function () { by(-1); });
    if (next) next.addEventListener('click', function () { by(1); });
    if (thumb) {
      el.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      setTimeout(update, 0);
    }
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-home-rail]').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
